<template>
  <editLeave :driverLeave="driverLeave" :loading="loading" />
</template>
<script>
import editLeave from './add.vue'
import { getDriverLeave } from '@/api/drivers'

export default {
  data() {
    return {
      driverLeave: null,
      loading: true,
    }
  },
  components: {
    editLeave,
  },
  created() {
    getDriverLeave.api(this.$route.params.id).then((res) => {
      this.driverLeave = {
        ...res,
        id: this.$route.params.id,
        disabled: this.$route.name.includes('VIEW') ? true : false,
      }
      this.loading = false
    })
  },
}
</script>
